import { useLocalStorageState } from 'ahooks';
import { useCallback } from 'react';

interface HelpState {
    memberIDs: number[];
}

interface UserData {
    ID: number;
    __typename: string;
}

export const useHelpState = () => {
    const [approveTagHelp, setApproveTagHelp] = useLocalStorageState<HelpState>(
        'approve-tag-help-state',
        { defaultValue: { memberIDs: [] } }
    );

    const addMember = useCallback(
        (user: UserData) => {
            if (
                user.__typename !== 'Me' ||
                !user.ID ||
                approveTagHelp.memberIDs.includes(user.ID)
            ) {
                return;
            }
            setApproveTagHelp({
                ...approveTagHelp,
                memberIDs: [...approveTagHelp.memberIDs, user.ID],
            });
        },
        [approveTagHelp, setApproveTagHelp]
    );

    const hasSeenHelp = useCallback(
        (user: UserData) => {
            return approveTagHelp.memberIDs.includes(user.ID);
        },
        [approveTagHelp]
    );

    return { hasSeenHelp, addMember };
};
